<app-dialog
	modalTitle="Upload do arquivo"
	titleButton="Enviar arquivo"
	[disabled]="!canSubmit"
	[secButton]="true"
	secTitleButton="Cancelar"
	(dialogClose)="onCancel()"
	(dialogSave)="onConfirm()"
>
	<div class="claim-usage-upload-dialog">
		<mat-form-field appearance="outline" class="full-width">
			<mat-label>Operadora</mat-label>
			<mat-select [formControl]="operatorControl">
				<mat-option
					*ngFor="let operatorOption of operatorOptions"
					[value]="operatorOption.value"
				>
					{{ operatorOption.label }}
				</mat-option>
			</mat-select>
			<mat-error *ngIf="operatorControl.hasError('required')">
				Informe a operadora.
			</mat-error>
		</mat-form-field>

		<mat-form-field appearance="outline" class="full-width">
			<mat-label>Competência</mat-label>
			<input
				matInput
				[formControl]="competenceControl"
				placeholder="MM/AAAA"
				autocomplete="off"
			/>
			<mat-error *ngIf="competenceControl.hasError('required')">
				Informe a competência.
			</mat-error>
		</mat-form-field>

		<label
			mat-stroked-button
			for="claimUsageFileInput"
			class="upload-button file-upload-trigger"
		>
			<mat-icon svgIcon="sanus-upload"></mat-icon>
			<span>Selecionar arquivo .txt</span>
		</label>
		<input
			id="claimUsageFileInput"
			type="file"
			accept=".txt"
			[multiple]="false"
			class="file-input"
			(change)="
				onFileSelected($any($event.target).files);
				$any($event.target).value = ''
			"
		/>

		<p class="error-message" *ngIf="errorMessage">{{ errorMessage }}</p>

		<div class="selected-file" *ngIf="selectedFile">
			<div>
				<p class="file-label">Arquivo selecionado</p>
				<p class="file-name">{{ selectedFile.name }}</p>
				<p class="file-size">{{ formatBytes(selectedFile.size) }}</p>
			</div>
			<button
				mat-icon-button
				type="button"
				aria-label="Remover arquivo selecionado"
				(click)="removeFile()"
			>
				<mat-icon svgIcon="sanus-closeb"></mat-icon>
			</button>
		</div>
	</div>
</app-dialog>
